var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class: _vm.isLoggedIn
        ? "wrapper d-flex align-items-stretch route-" +
          _vm.$router.currentRoute.name
        : ""
    },
    [
      _c("Header"),
      _vm._v(" "),
      _c(
        "div",
        {
          class: _vm.isLoggedIn ? "side-nav-active" : "",
          attrs: { id: "content" }
        },
        [_c("router-view")],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.dataLoading && _vm.onlyOneSpinner(),
              expression: "dataLoading && onlyOneSpinner()"
            }
          ],
          attrs: { id: "global-spinner" }
        },
        [_c("b-spinner", { attrs: { label: "Loading" } })],
        1
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          attrs: {
            centered: "",
            "hide-footer": "",
            id: "socialMediaExportModal",
            title: "Creating Social Media Export"
          },
          model: {
            value: _vm.showSocialMediaExportModal,
            callback: function($$v) {
              _vm.showSocialMediaExportModal = $$v
            },
            expression: "showSocialMediaExportModal"
          }
        },
        [
          _c(
            "div",
            { staticStyle: { "text-align": "center" } },
            [
              _vm.isLoadingExport
                ? _c("b-spinner", { attrs: { label: "Loading" } })
                : _vm._e(),
              _vm._v(" "),
              !_vm.isLoadingExport
                ? _c("div", [
                    _vm.downloadLink
                      ? _c(
                          "a",
                          {
                            staticClass: "btn btn-primary",
                            attrs: { href: _vm.downloadLink },
                            on: {
                              click: function($event) {
                                _vm.showSocialMediaExportModal = false
                              }
                            }
                          },
                          [_vm._v("Download")]
                        )
                      : _vm._e()
                  ])
                : _vm._e()
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          attrs: {
            centered: "",
            "hide-footer": "",
            "hide-backdrop": "",
            "no-close-on-backdrop": "",
            "content-class": "shadow",
            id: "socialMediaImportModal",
            title: "Import Social Media Posts"
          },
          model: {
            value: _vm.showSocialMediaImportModal,
            callback: function($$v) {
              _vm.showSocialMediaImportModal = $$v
            },
            expression: "showSocialMediaImportModal"
          }
        },
        [
          _c("p", [
            _c(
              "a",
              {
                attrs: {
                  href: "/assets/import-social-media.xlsx",
                  target: "_blank"
                }
              },
              [_vm._v("Download example .xlsx file")]
            )
          ]),
          _vm._v(" "),
          _c("VueFilePond", {
            ref: "importPond",
            attrs: {
              name: "file",
              "label-idle": "Upload .xlsx",
              "allow-multiple": true,
              dropOnElement: true,
              dropOnPage: false,
              allowRevert: false,
              files: _vm.filepond,
              credits: "false"
            },
            on: { init: _vm.handleFilePondInit }
          }),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.loadedImportResults,
                  expression: "loadedImportResults"
                }
              ],
              staticClass: "imported-results"
            },
            [
              _c(
                "b-button",
                {
                  directives: [
                    {
                      name: "b-toggle",
                      rawName: "v-b-toggle.collapse-import-results",
                      modifiers: { "collapse-import-results": true }
                    }
                  ],
                  attrs: { variant: "text" }
                },
                [
                  _c("i", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: !_vm.expandImportResults,
                        expression: "!expandImportResults"
                      }
                    ],
                    staticClass: "fas fa-chevron-down collapse-indicator"
                  }),
                  _vm._v(" "),
                  _c("i", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.expandImportResults,
                        expression: "expandImportResults"
                      }
                    ],
                    staticClass: "fas fa-chevron-right collapse-indicator"
                  }),
                  _vm._v(" "),
                  _vm.importedResults.errors.length > 0
                    ? _c(
                        "strong",
                        {
                          staticStyle: { color: "var(--error--color--border)" }
                        },
                        [
                          _vm._v(
                            "ERROR: " +
                              _vm._s(_vm.importedResults.errors.length) +
                              " row(s) have problems."
                          )
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c("strong", [
                    _vm._v(
                      _vm._s(_vm.importedResults.imported.length) +
                        " posts imported."
                    )
                  ]),
                  _vm._v(" "),
                  _c("strong", [
                    _vm._v(
                      _vm._s(_vm.importedResults.total) + " data rows in file."
                    )
                  ]),
                  _vm._v(" "),
                  _c("strong", [_vm._v("Click to view details.")]),
                  _vm._v(" "),
                  _c("br")
                ]
              ),
              _vm._v(" "),
              _c(
                "b-collapse",
                {
                  attrs: { id: "collapse-import-results" },
                  model: {
                    value: _vm.expandImportResults,
                    callback: function($$v) {
                      _vm.expandImportResults = $$v
                    },
                    expression: "expandImportResults"
                  }
                },
                [
                  _c("div", { staticClass: "collapse-inner" }, [
                    _vm.importedResults.errors.length > 0
                      ? _c(
                          "ol",
                          _vm._l(_vm.importedResults.errors, function(
                            e,
                            indexe
                          ) {
                            return _c(
                              "li",
                              {
                                class:
                                  "{e.new ? 'imported-new':'imported-existing'}"
                              },
                              [
                                _c("span", { staticClass: "imported-title" }, [
                                  _vm._v(_vm._s(e.title))
                                ]),
                                _vm._v(" "),
                                e.publish_date != null
                                  ? _c(
                                      "span",
                                      { staticClass: "imported-publish_date" },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm._f("moment")(
                                              e.publish_date,
                                              "MMM D,YYYY HH:mm a"
                                            )
                                          )
                                        )
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                e.publish_date == null
                                  ? _c(
                                      "span",
                                      { staticClass: "imported-publish_date" },
                                      [_vm._v("No Date Set")]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                e.social_campaign
                                  ? _c(
                                      "span",
                                      {
                                        staticClass: "imported-social_campaign"
                                      },
                                      [
                                        _vm._v(
                                          "Campaign: " +
                                            _vm._s(e.social_campaign.title)
                                        )
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                e.social_series
                                  ? _c(
                                      "span",
                                      { staticClass: "imported-social_series" },
                                      [
                                        _vm._v(
                                          "Series: " +
                                            _vm._s(e.social_series.title)
                                        )
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  { class: _vm.getImportStatusClass(e.status) },
                                  [
                                    _vm._v(
                                      "Row " +
                                        _vm._s(e.row) +
                                        "; " +
                                        _vm._s(e.status.name)
                                    )
                                  ]
                                )
                              ]
                            )
                          }),
                          0
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.importedResults.imported.length > 0
                      ? _c(
                          "ol",
                          _vm._l(_vm.importedResults.imported, function(
                            s,
                            index
                          ) {
                            return _c(
                              "li",
                              {
                                class:
                                  "{s.new ? 'imported-new':'imported-existing'}"
                              },
                              [
                                _c("span", { staticClass: "imported-title" }, [
                                  _c(
                                    "a",
                                    {
                                      on: {
                                        click: function($event) {
                                          return _vm.showEditDeliverableModal(s)
                                        }
                                      }
                                    },
                                    [_vm._v(_vm._s(s.title))]
                                  )
                                ]),
                                _vm._v(" "),
                                s.publish_date != null
                                  ? _c(
                                      "span",
                                      { staticClass: "imported-publish_date" },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm._f("moment")(
                                              s.publish_date,
                                              "MMM D,YYYY HH:mm a"
                                            )
                                          )
                                        )
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                s.publish_date == null
                                  ? _c(
                                      "span",
                                      { staticClass: "imported-publish_date" },
                                      [_vm._v("No Date Set")]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                s.social_campaign
                                  ? _c(
                                      "span",
                                      {
                                        staticClass: "imported-social_campaign"
                                      },
                                      [
                                        _vm._v(
                                          "Campaign: " +
                                            _vm._s(s.social_campaign.title)
                                        )
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                s.social_series
                                  ? _c(
                                      "span",
                                      { staticClass: "imported-social_series" },
                                      [
                                        _vm._v(
                                          "Series: " +
                                            _vm._s(s.social_series.title)
                                        )
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  { class: _vm.getImportStatusClass(s.status) },
                                  [
                                    _vm._v(
                                      "Row " +
                                        _vm._s(s.row) +
                                        "; " +
                                        _vm._s(s.status.name)
                                    )
                                  ]
                                )
                              ]
                            )
                          }),
                          0
                        )
                      : _vm._e()
                  ])
                ]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }